import RoutesPage from "Components/Routes";

function App() {
  return <RoutesPage />;
}

export default App;
